<template>
  <el-container>
    <el-main class="main">
      <el-form class="form" :model="ruleForm" ref="ruleForm">
        <el-input size="small" style="width: 220px" v-model="ruleForm.name" placeholder="按图文标题搜索"></el-input>
        <el-select size="small" placeholder="请选择导航分类" v-model="ruleForm.navName" style="margin-left: 20px">
          <el-option
            v-for="item in navList"
            :key="item.name"
            :label="item.name"
            :value="item.name">
          </el-option>
        </el-select>
        <el-button size="small" type="primary" icon="el-icon-search" style="margin-left: 20px" @click="getList">搜索</el-button>
        <el-button size="small" style="margin-left: 20px" @click="resetForm()">重置</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" style="float: right" @click="toTeletextAdd">添加图文</el-button>
      </el-form>
      <el-table border style="margin-top: 20px" :data="tableList">
        <el-table-column label="排序" prop="priority"></el-table-column>
        <el-table-column label="封面图">
          <template slot-scope="scope">
            <el-image class="image" :src="scope.row.imgUrl"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="图文标题" prop="name"></el-table-column>
        <el-table-column label="所属导航" prop="navName"></el-table-column>
        <el-table-column label="作者" prop="author"></el-table-column>
        <el-table-column label="创建时间" prop="createTime"></el-table-column>
        <el-table-column label="修改时间" prop="updateTime"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="warning" size="mini" icon="el-icon-edit" @click="toNavEdit(scope.row)">编辑</el-button>
            <el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteById(scope.row.id)" :loading="loading">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
  </el-container>
</template>

<script>
import {deleteArticleByIds, queryArticlePageList} from "../../../../api/system/articleSettings";
import {mapGetters} from "vuex";
import {getCompanyByAdmin} from "../../../../api/system/org-storage";

export default {
  name: "index",
  data(){
    return{
      groupName:'',
      tableList:[],
      loading:false,
      companyId:'',
      navList:[],
      ruleForm:{
        id:'',
        navName:'',
        name:'',
      },
    }
  },
  computed: {
    ...mapGetters(["currentUser"])
  },
  mounted() {
    this.getCompanyByAdmin()
  },
  methods:{
    getNavList(){
      let param = {}
      param.type = 1
      param.companyId = this.companyId
      queryArticlePageList(param).then(res => {
        // console.log(res.data);
        this.navList = res.data.records
      }).catch(err=>{
        console.log(err)
      })
    },
    getCompanyByAdmin(){
      let param = {'id':this.currentUser.id}
      getCompanyByAdmin(param).then(res => {
        if(res.data.length > 0){
          this.companyId = res.data[0].id
        }
        this.getNavList()
        this.getList()
      }).catch(err=>{
        console.log(err)
      })
    },
    getList(){
      let param = {}
      param.type = 2
      param.name = this.ruleForm.name
      param.navName = this.ruleForm.navName
      param.companyId = this.companyId
      queryArticlePageList(param).then(res => {
        // console.log(res.data);
        this.tableList = res.data.records
      }).catch(err=>{
        console.log(err)
      })
    },
    toTeletextAdd() {
      this.$router.push({path: "/teleTextAdd"});
    },
    deleteById(id){
      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let param = []
        param.push(id)
        // console.log(param)
        this.loading = true
        deleteArticleByIds(param).then(res => {
          if(res.code === 200){
            this.$modal.msgSuccess("删除成功！");
            this.loading = false
            this.getList()
          }else{
            this.$modal.msgError("删除失败，请重试");
            this.loading = false
          }
        }).catch(()=>{
          this.loading = false
        });
      }).catch(() => {
        this.$modal.msg("已取消删除");
        this.loading = false
      });
    },
    resetForm() {
      this.ruleForm.navName = ''
      this.ruleForm.name= ''
      this.getList()
    },
    toNavAdd() {
      this.$router.push({path: "/teletextAdd"});
    },
    toNavEdit(teletextList) {
      this.$router.push({name: "TeletextAdd",params:{'teletextList':JSON.stringify(teletextList)}});
    }
  }
}
</script>

<style scoped>
  .image{
    height: 60px;
  }
  .main{
    overflow: auto;
    height: 90vh;
  }
</style>
